import { IonContent, IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { DominateFooter } from '@/pages/Onboarding/Layouts/OwnAI_DominateV2/components/DominateFooter';
import { canLogEvents } from '@/utils/canLogEvents';

import { useSummaryPreload } from '../../hooks/useSummaryPreload';

import { ContentContainerStyles, PageStyles } from './Protect.styles';

export const ScreenProtect: React.FC = () => {
  const { preloadSummaryImages } = useSummaryPreload();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Protect',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    preloadSummaryImages('summary-final');
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination">
      <IonContent>
        <ContentContainerStyles>
          <IonIcon
            icon={lockClosed}
            style={{
              fontSize: '32px',
              color: 'white',
              marginBottom: '8px',
            }}
          />
          <OwnAiTitle className={'title'}>I protect what's mine</OwnAiTitle>
          <OnboardingSubtitle>
            and right now, that includes you
          </OnboardingSubtitle>
        </ContentContainerStyles>
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="Your secrets stay where I put them: safe, silent, unseen"
          buttonText="Yes, Mistress"
          variant="with-quotes"
        />
      </IonContent>
    </PageStyles>
  );
};
